import { PropsWithChildren } from 'react';

import classNames from 'classnames';

import { Card } from '@anyx/shared-ui';


export const Shell = ({
  children,
  className,
}: PropsWithChildren<{
  className?: string;
}>) => {
  return (
    <Card withPadding={false} className={classNames('relative mt-4 flex border', className)}>
      {children}
    </Card>
  );
};
